/**
 * Shopify Storefront Client
 * This class initializes the Shopify Storefront API client and attaches it to the global `window` object.
 * It provides a connection to the Shopify Storefront API using the given store domain, API version, and public access token.
 */
class ShopifyStorefrontClient {
  /**
   * Constructor initializes the Shopify Storefront API client.
   * It attaches the client to the global `window` object for accessibility throughout the application.
   */
  constructor() {
    if (!ShopifyStorefrontAPIClient) {
      console.error("ShopifyStorefrontAPIClient is not defined. Make sure the SDK is properly loaded.");
      return;
    }

    window.storefrontClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
      storeDomain: 'battlboxllc.myshopify.com',
      apiVersion: '2025-01',
      publicAccessToken: '6e141039d6b32e1d30e717e19adac8c8',
    });
  }
}

// Instantiate the ShopifyStorefrontClient
new ShopifyStorefrontClient();
